import React from 'react'
import { Col, Form, FormGroup, Label, Input } from 'reactstrap';

export const FormBacteriumCountText = (props) => {

    const { handleInputChange, methodAction, name } = props;

    return (
        <Form className="" role="form" onSubmit={methodAction}>

            <Col md="12">
                <FormGroup>
                    <Label className="col-form-label">Bacteria <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        type="text"
                        className="form-control form-control-sm input-air-primary"
                        name="name"
                        onChange={handleInputChange}
                        value={name}
                        autoComplete="off"
                    />
                </FormGroup>
            </Col>


        </Form>
    )
}
